import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import config from "src/config/config";
import { withAppContext } from 'src/store/initAppContext'
import styled, { withTheme } from 'styled-components'
import { theme } from 'styled-tools';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';

const WorldCupDoubleCashBack = (props) => {
    const {
        app: { brandId },
        theme,
    } = props;

    const navigate = useNavigate()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const domain = brandId == 31 || brandId == 32 ? "Yolo247" : "BaaziAdda";

    return (
        <>
            <MainWrapper>
                <ContentWrapper>
                    {/* <TeamsSection>
                        <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.WorldCupDoubleCashBackTeamsImage}`} effect="none" placeholder={<PlaceholderImage />} />
                    </TeamsSection> */}
                    <BonusTitle className='textCenter'>
                        <h1>Daily Deposit Bonus on Yolo247 | 8% Weekly Double Cashback</h1>
                    </BonusTitle>
                    <TitleText>
                        <p>Consistency should be rewarded, and that is what Yolo247 believes in. Our daily depositors <br />
                         get an astounding weekly cashback of up to 8%.</p>
                    </TitleText>
                    <TitleText>
                        <p>Step up to the challenge, deposit daily, play daily, and win daily on your favourite online sports betting and casino games platform, Yolo247.</p>
                    </TitleText>
                    <CashBackWrapper>
                        <LeftImgContent>
                            <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.WorldCupDoubleCashBackMobileImage}`} effect="none" placeholder={<PlaceholderImage />} />
                        </LeftImgContent>
                        <BorderLine></BorderLine>
                        <RightTextContent>
                            <BonusTitle className='textCenter'>
                                <h1>Deposit Daily for 8% Weekly Double Cashback</h1>
                            </BonusTitle>
                            <BonusBody>
                                <BonusContent>
                                    <ul>
                                        <li>Just like consistency is key to the success of any player, show that you are one of the top players by depositing daily.</li>
                                        <li>Unlock the fantastic additional cashback by maintaining the deposit streak for all seven days of the week.</li>
                                        <li>Once you deposit daily for a week, you will be eligible for the additional cashback. Raise your game!</li>
                                    </ul>
                                </BonusContent>
                            </BonusBody>
                        </RightTextContent>
                    </CashBackWrapper>
                    <WeeklyBonusWrapper>
                        <WeeklyBonusContent>
                            <h1>Losing? We Don't Know That</h1>
                            <p>Yolo247 is a place where there is no such thing as losing! Thanks to the daily deposit bonus, you will get up to 8% cashback on your weekly losses. <br /> <br /> Dare to Dream! Dare to Win!</p>
                        </WeeklyBonusContent>
                        <WeeklyBonusContent>
                            <h1>Monday Blues? No No! Monday Greens!</h1>
                            <p>With extra bonus credited on each Monday, your Yolo247 account and you will be beaming with a smile!</p>
                        </WeeklyBonusContent>
                    </WeeklyBonusWrapper>
                    <Divider></Divider>
                    <DailyBonusWrapper>
                        <DailyBonusTitle>
                            <h1>Tier - Wise Daily Deposit Bonus</h1>
                        </DailyBonusTitle>
                        <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.WorldCupDoubleCashBackWeeklyBonusTable}`} effect="none" placeholder={<PlaceholderImage />} />
                    </DailyBonusWrapper>
                    <Divider></Divider>
                    <TermsAndCondition>
                    <h4>Terms & Conditions</h4>
                        <ul>
                            <li>This promotion is valid for all new and existing {domain} users.</li>
                            <li>This bonus amount will be capped at INR 7,000.</li>
                            <li>The bonus amount will be credited to your main wallet as cashback bonus every Monday, provided that you have successfully deposited all 7 days in a week (Mon-Sun).</li>
                            <li>Multiple accounts will not be considered for this promotion. All players will be subject to duplicate checking. {domain} reserves the right to disqualify players if any collusion or foul play takes place in the promotion.</li>
                            <li>This promotion cannot be used in conjunction with, or to contribute to the eligibility for, any other promotion.</li>
                            <li>{domain} reserves the right to amend, cancel, and reclaim or refuse any promotion at its discretion.</li>
                            <li>If any fraudulent activity of the player(s) is identified, {domain} reserves the right to withhold the funds and reject the withdrawals.</li>
                            <li>{domain} general terms & conditions apply.</li>
                        </ul>
                    </TermsAndCondition>
                </ContentWrapper>
            </MainWrapper>
        </>
    )
}

export default withTheme(withAppContext(WorldCupDoubleCashBack));

//Styled Components

const MainWrapper = styled.div`
    width: 98%;
    height: auto;
    border: 1px solid white;
    border-top: 0;
    display: flex;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em;
    -webkit-backdrop-filter: brightness(0.5);
    backdrop-filter: brightness(0.5);
`;

const ContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.WorldCupDoubleCashBackBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 2rem;

    .lazy-load-image-background {
      display: flex !important;
      justify-content: center !important;
    }

    .secondTitle {
        padding-top: 2rem;
    }

    .textCenter {
        justify-content: center;
    }
`;

const TeamsSection = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 0rem 15rem;
    margin: 3.5rem 0;
    gap: 20px;
    position: relative;

    img{
        width: 100%;
    }
`;

const TitleText = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 73%;

    p {
        color: #FFF;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .blue {
        color: #6F6DE6;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
    .yellow {
        color: #FFD085;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const CashBackWrapper = styled.div`
    display: flex;
    padding: 2rem 8rem;
    width: 100%;
    justify-content: stretch;
    align-items: center;
`;

const LeftImgContent = styled.div`
    display: flex;
    width: 40%;
    text-align: right;
    justify-content: center;
    align-items: flex-end;

    img {
        width: 55%;
        align-self: flex-end;
    }
`;

const BorderLine = styled.div`
    width: 2px;
    background: linear-gradient(transparent, #B28C04, transparent);
    height: 70%;
    align-self: center;
`;

const RightTextContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    background: radial-gradient(circle at left, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 20%);
    padding: 1rem 1rem 1rem 4rem;
    height: 70%;
`;

const BonusTitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background:  #FAE74F;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: 80%;

    h1 {
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const BonusBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`;

const BonusContent = styled(BonusBody)`
    width: 90%;

    h1 {
        background: linear-gradient(180deg, #FAE74F 0%, #BA5901 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: capitalize;
        margin-bottom: 0;
    }
    p {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize; 
        padding-left: 1rem;
    }

    & ul {
        padding-left: 2%;
        margin: 5px 0px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        & li {
            color: #FFF;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-transform: capitalize; 
            padding-left: 1rem;
        }
    }
`;

const WeeklyBonusWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 3rem;
    width: 80%;
    padding: 3rem;
`;

const WeeklyBonusContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #597AA1;
    border-radius: 8px;
    width: 50%;
    padding: 1rem 2rem;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.WorldCupDoubleCashBackWeeklyBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;

    h1 {
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: capitalize;
        background: #FAE74F;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    p {
        color: #FFF;
        text-align: justify;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const DailyBonusWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2rem 2rem 3rem 2rem;
    background: radial-gradient(38.26% 45.18% at 50% 0%, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 100%);

    img {
        width: 70%;
    }
`;

const Divider = styled.div`
    height: 2px;
    width: 100%;
    background: radial-gradient(#B28C04 0%, #00000000 50%);
`;


const DailyBonusTitle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FAE74F;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-bottom: 1rem;
    position: relative;

    ::before {
        content: "";
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.WcDoublecashBackFireBall")});
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        position: absolute;
        right: 6%;
        bottom: -25%;
        width: 12rem;
        height: 8rem;
    }
    
    h1 {
        text-align: center;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin-top: 0;
        width: 30%;
    }
`

const TermsAndCondition = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    background: radial-gradient(38.26% 45.18% at 50% 0%, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 100%);
    width: 65%;

    & li {
        color: #FFF;
        text-align: justify;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 116.667% */
        text-transform: capitalize;
        list-style-type: decimal;
        padding-bottom: 1.5rem;
    }

    & h4 {
        background: #FAE74F;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;
